import { graphql } from 'react-relay/legacy.js';

export const PhotoRootQuery = graphql`
    query PhotoRootQuery($urlLabels: [String!]!, $userId: String, $hasUserId: Boolean = false) {
        viewer {
            ...InteriorPhotoWrapper_viewer
        }
    }
`;
